<template>
    <table class="">
        <tbody>
            <tr
                v-for="(item, idx) in item"
                :key="`item-${id}-${idx}`">
                <td v-if="item.name">
                    {{ item.name }}
                </td>
                <td>
                    <template v-if="item.value">
                        <template v-if="isPrimitive(item.value)">
                            <primitive-element :item="item"/>
                        </template>
                        <template v-else-if="isArray(item.value)">
                            <p
                                class="mb-0"
                                v-for="(child, idxChild) in item.value"
                                :key="`item-child-${id}-${idxChild}`">
                                <template v-if="isObject(child)">
                                    {{ resolvePath(child, 'name') }}
                                </template>
                                <template v-else-if="isPrimitive(child)">
                                    {{ child }}
                                </template>
                            </p>
                        </template>
                    </template>
                    <template v-else-if="isArray(item)">
                        <group-element
                            :id="`child-${id}`"
                            :item="item" />
                    </template>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>

import {isPrimitive, isArray, isObject, resolvePath} from '@config/utils';
import GroupElement from './GroupElement'

export default
{
    name: 'GroupElement',
    mixins: [
    ],
    components: {
        GroupElement,
        PrimitiveElement: () => import(/* webpackChunkName: "viewer-primitive-element" */ './PrimitiveElement'),
    },
    props: {
        id: {
            type: Number|String,
            default: '',
        },
        item: {
            type: Array,
            require: true,
        }
    },
    data() {
        return {

        }
    },
    methods: {
        isArray,
        isPrimitive,
        isObject,
        resolvePath,
    },
}

</script>

<style scoped lang="scss">
</style>